<template>
  <div>
    <div v-if="stage === 'selectMethod'" class="invite selection">
      <button class="clavo-button secondary" @click="stage = 'byMail'">
        <span class="icon-w-text">
          <svg height="30" width="30" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M28.044 5H1.956C.876 5 0 5.881 0 6.969V24.03C0 25.12.877 26 1.956 26h26.088c1.08 0 1.956-.881 1.956-1.969V6.97A1.963 1.963 0 0028.044 5zm0 1.312a.652.652 0 01.651.657v1.293l-13.33 9.144a.65.65 0 01-.73 0L1.304 8.261V6.969c0-.363.292-.657.652-.657zM1.956 24.688a.655.655 0 01-.651-.657V9.85l8.373 5.746-5.869 5.378a.665.665 0 00-.049.935c.243.272.66.294.93.05l6.107-5.578 3.111 2.132c.664.457 1.54.457 2.204 0l3.11-2.132 6.108 5.578c.27.244.686.222.93-.05a.665.665 0 00-.05-.935l-5.869-5.378 8.355-5.746v14.182a.657.657 0 01-.652.657z"
              fill="#4b61ee"
              fill-rule="evenodd"
            />
          </svg>
          <span>{{ $t('invitebyEmail') }}</span>
        </span>
        <svg class="arrow" width="22" height="21" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21.161 10.145l-.007-.012a.75.75 0 00-.124-.163l-9-9a.75.75 0 00-1.133.976l.073.084 7.72 7.72H1.5a.75.75 0 00-.102 1.493l.102.007h17.189l-7.72 7.72a.75.75 0 00.977 1.133l.084-.073 9-9 .064-.072a.753.753 0 00.007-.01l-.07.082a.753.753 0 00.16-.238l.009-.021a.746.746 0 00.005-.014l.007-.02a.748.748 0 00.038-.237v-.016c0-.02-.002-.041-.004-.061l.004.077a.756.756 0 00-.015-.148 1.325 1.325 0 00-.018-.073l-.005-.014-.004-.013a.746.746 0 00-.041-.096l-.006-.01z"
            fill="#4B61EE"
            fill-rule="nonzero"
          />
        </svg>
      </button>

      <button class="clavo-button secondary" @click="generateMagicLink">
        <span class="icon-w-text">
          <svg height="30" width="30" xmlns="http://www.w3.org/2000/svg">
            <g fill="#4b61ee">
              <path
                d="M10.616 11.752a5.75 5.75 0 018.132 0 .75.75 0 01-1.06 1.06 4.25 4.25 0 00-5.847-.155l-.164.156-6.364 6.364a4.25 4.25 0 106.01 6.01l3.406-3.406a.75.75 0 011.061 1.06l-3.406 3.407A5.75 5.75 0 014.075 18.3l.177-.185z"
              />
              <path
                d="M18.616 2.752a5.75 5.75 0 018.309 7.947l-.177.185-6.364 6.364a5.75 5.75 0 01-8.132 0 .75.75 0 011.06-1.06 4.25 4.25 0 005.847.155l.164-.156 6.364-6.364a4.25 4.25 0 10-6.01-6.01l-2.841 2.841a.75.75 0 01-1.134-.977l.073-.084z"
              />
            </g>
          </svg>
          <span>{{ $t('invitebyLink') }}</span>
        </span>
        <svg class="arrow" width="22" height="21" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21.161 10.145l-.007-.012a.75.75 0 00-.124-.163l-9-9a.75.75 0 00-1.133.976l.073.084 7.72 7.72H1.5a.75.75 0 00-.102 1.493l.102.007h17.189l-7.72 7.72a.75.75 0 00.977 1.133l.084-.073 9-9 .064-.072a.753.753 0 00.007-.01l-.07.082a.753.753 0 00.16-.238l.009-.021a.746.746 0 00.005-.014l.007-.02a.748.748 0 00.038-.237v-.016c0-.02-.002-.041-.004-.061l.004.077a.756.756 0 00-.015-.148 1.325 1.325 0 00-.018-.073l-.005-.014-.004-.013a.746.746 0 00-.041-.096l-.006-.01z"
            fill="#4B61EE"
            fill-rule="nonzero"
          />
        </svg>
      </button>

      <button class="clavo-button secondary" @click="goToIntegrations('slack')">
        <span class="icon-w-text">
          <svg height="30" width="30" xmlns="http://www.w3.org/2000/svg">
            <g fill="none">
              <g fill="#e01e5a">
                <path
                  d="M6.303 18.958c0 1.734-1.417 3.151-3.152 3.151S0 20.692 0 18.958s1.417-3.152 3.151-3.152h3.152zM7.89 18.958a3.16 3.16 0 013.152-3.152 3.16 3.16 0 013.152 3.152v7.89A3.16 3.16 0 0111.042 30a3.16 3.16 0 01-3.151-3.151z"
                />
              </g>
              <g fill="#36c5f0">
                <path
                  d="M11.042 6.303c-1.734 0-3.151-1.417-3.151-3.152S9.308 0 11.042 0a3.16 3.16 0 013.152 3.151v3.152zM11.042 7.89a3.16 3.16 0 013.152 3.152 3.16 3.16 0 01-3.152 3.152h-7.89A3.16 3.16 0 010 11.042a3.16 3.16 0 013.151-3.151z"
                />
              </g>
              <g fill="#2eb67d">
                <path
                  d="M23.697 11.042a3.16 3.16 0 013.152-3.151A3.16 3.16 0 0130 11.042a3.16 3.16 0 01-3.151 3.152h-3.152zM22.11 11.042c0 1.735-1.418 3.152-3.152 3.152s-3.152-1.417-3.152-3.152v-7.89C15.806 1.416 17.223 0 18.958 0s3.151 1.417 3.151 3.151z"
                />
              </g>
              <g fill="#ecb22e">
                <path
                  d="M18.958 23.697a3.16 3.16 0 013.151 3.152c0 1.734-1.417 3.151-3.151 3.151s-3.152-1.417-3.152-3.151v-3.152zM18.958 22.11c-1.735 0-3.152-1.418-3.152-3.152s1.417-3.152 3.152-3.152h7.89c1.735 0 3.152 1.417 3.152 3.152s-1.417 3.151-3.151 3.151z"
                />
              </g>
            </g>
          </svg>
          <span>{{ $t('invitebySlack') }}</span>
        </span>
        <svg class="arrow" width="22" height="21" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21.161 10.145l-.007-.012a.75.75 0 00-.124-.163l-9-9a.75.75 0 00-1.133.976l.073.084 7.72 7.72H1.5a.75.75 0 00-.102 1.493l.102.007h17.189l-7.72 7.72a.75.75 0 00.977 1.133l.084-.073 9-9 .064-.072a.753.753 0 00.007-.01l-.07.082a.753.753 0 00.16-.238l.009-.021a.746.746 0 00.005-.014l.007-.02a.748.748 0 00.038-.237v-.016c0-.02-.002-.041-.004-.061l.004.077a.756.756 0 00-.015-.148 1.325 1.325 0 00-.018-.073l-.005-.014-.004-.013a.746.746 0 00-.041-.096l-.006-.01z"
            fill="#4B61EE"
            fill-rule="nonzero"
          />
        </svg>
      </button>
      <button v-if="false" class="clavo-button secondary" @click="goToIntegrations('teams')">
        <span class="icon-w-text">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30">
            <defs>
              <linearGradient id="a" x1="17.372%" x2="82.628%" y1="-6.51%" y2="106.51%">
                <stop offset="0%" stop-color="#5A62C3" />
                <stop offset="50%" stop-color="#4D55BD" />
                <stop offset="100%" stop-color="#3940AB" />
              </linearGradient>
            </defs>
            <g fill="none" transform="translate(0 1)">
              <path
                fill="#5059C9"
                d="M20.925 10.465h7.75c.732 0 1.325.594 1.325 1.326v7.058a4.872 4.872 0 0 1-4.872 4.872h-.023a4.872 4.872 0 0 1-4.872-4.871v-7.692c0-.383.31-.693.692-.693Z"
              />
              <circle cx="26.163" cy="5.93" r="3.14" fill="#5059C9" />
              <circle cx="16.395" cy="4.535" r="4.535" fill="#7B83EB" />
              <path
                fill="#7B83EB"
                d="M22.442 10.465H9.651a1.312 1.312 0 0 0-1.279 1.342v8.05a7.87 7.87 0 0 0 7.675 8.05 7.87 7.87 0 0 0 7.674-8.05v-8.05a1.312 1.312 0 0 0-1.279-1.342Z"
              />
              <path
                fill="#000"
                d="M16.744 10.465v11.282a1.284 1.284 0 0 1-1.277 1.276H8.986a8.497 8.497 0 0 1-.614-3.167v-8.051a1.31 1.31 0 0 1 1.277-1.34h7.095Z"
                opacity=".1"
              />
              <path
                fill="#000"
                d="M16.047 10.465v11.98a1.284 1.284 0 0 1-1.277 1.277l-5.456-.001c-.119-.23-.23-.46-.328-.698a6.92 6.92 0 0 1-.244-.697 8.497 8.497 0 0 1-.37-2.47v-8.051a1.31 1.31 0 0 1 1.277-1.34h6.398Z"
                opacity=".2"
              />
              <path
                fill="#000"
                d="M16.047 10.465V21.05a1.287 1.287 0 0 1-1.277 1.277H8.742a8.497 8.497 0 0 1-.37-2.47v-8.051a1.31 1.31 0 0 1 1.277-1.34h6.398Z"
                opacity=".2"
              />
              <path
                fill="#000"
                d="M15.349 10.465V21.05a1.287 1.287 0 0 1-1.277 1.277h-5.33a8.497 8.497 0 0 1-.37-2.47v-8.051a1.31 1.31 0 0 1 1.277-1.34h5.7Z"
                opacity=".2"
              />
              <path
                fill="#000"
                d="M16.744 6.858v2.198c-.118.007-.23.014-.349.014-.118 0-.23-.007-.348-.014a3.829 3.829 0 0 1-.698-.112 4.535 4.535 0 0 1-3.14-2.665 3.877 3.877 0 0 1-.223-.698h3.481a1.282 1.282 0 0 1 1.277 1.277Z"
                opacity=".1"
              />
              <path
                fill="#000"
                d="M16.047 7.556v1.5a3.829 3.829 0 0 1-.698-.112 4.535 4.535 0 0 1-3.14-2.665h2.56a1.282 1.282 0 0 1 1.278 1.277Z"
                opacity=".2"
              />
              <path
                fill="#000"
                d="M16.047 7.556v1.5a3.829 3.829 0 0 1-.698-.112 4.535 4.535 0 0 1-3.14-2.665h2.56a1.282 1.282 0 0 1 1.278 1.277Z"
                opacity=".2"
              />
              <path fill="#000" d="M15.349 7.556v1.388a4.535 4.535 0 0 1-3.14-2.665h1.863a1.282 1.282 0 0 1 1.277 1.277Z" opacity=".2" />
              <path
                fill="url(#a)"
                d="M1.279 6.28H14.07c.706 0 1.279.572 1.279 1.278v12.791a1.28 1.28 0 0 1-1.279 1.279H1.279A1.279 1.279 0 0 1 0 20.349V7.558a1.28 1.28 0 0 1 1.279-1.279Z"
              />
              <path fill="#FFF" class="negative" d="M11.04 11.147H8.483v6.963H6.854v-6.963H4.309v-1.35h6.731z" />
            </g>
          </svg>
          <span>{{ $t('invitebyMSTeams') }}</span>
        </span>
        <svg class="arrow" width="22" height="21" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21.161 10.145l-.007-.012a.75.75 0 00-.124-.163l-9-9a.75.75 0 00-1.133.976l.073.084 7.72 7.72H1.5a.75.75 0 00-.102 1.493l.102.007h17.189l-7.72 7.72a.75.75 0 00.977 1.133l.084-.073 9-9 .064-.072a.753.753 0 00.007-.01l-.07.082a.753.753 0 00.16-.238l.009-.021a.746.746 0 00.005-.014l.007-.02a.748.748 0 00.038-.237v-.016c0-.02-.002-.041-.004-.061l.004.077a.756.756 0 00-.015-.148 1.325 1.325 0 00-.018-.073l-.005-.014-.004-.013a.746.746 0 00-.041-.096l-.006-.01z"
            fill="#4B61EE"
            fill-rule="nonzero"
          />
        </svg>
      </button>

      <!-- <div v-if="onboarding" class="integrations-info">
        <p>{{ $t('youCanAlsoInvitePeopleViaIntegrations') }}</p>
        <p>{{ $t('toDoSoGoTo') }}&nbsp;
          <span>
            {{ $t('teamSettings') }}<img src="@/assets/_desktop/_calendars/DP-Arrow.svg">{{ $t('teamIntegrationsTabName') }}
          </span>
        </p>
      </div> -->

      <p v-if="modal === false" class="skip">
        <!-- <a
          href=""
          class="clavo-link primary"
          @click.prevent="$emit('done')"
        >Skip for now</a> -->
        <button :class="{ inactive: team == '' || showProgressBar }" class="clavo-button big primary" @click="$emit('done')">
          {{ $t('continue') }}
        </button>
      </p>
    </div>
    <div v-else-if="stage === 'byMail'" class="invite email" :class="{ modal: modal }">
      <div v-if="showProgressBar" class="progress-bar-wrapper">
        <p>{{ $t('addedXofY', { x: currentMails, y: totalMails }) }}</p>
        <progress-bar :current="currentMails" :total="totalMails" />
      </div>
      <div v-if="mode === 'connect-clavo-to-integration'" class="c-h-top">
        <search-bar v-model="search" class="search-user" :placeholder="$t('searchUserPlaceholder')" @input="searchMembers" />
      </div>
      <div v-if="mode === 'integration-not-in-clavo' && members.length > 0" class="check-all-outer-wrapper">
        <div class="check-all-inner-wrapper">
          <div class="grid-item">
            <checkbox v-model="allChecked" :initial-state="allChecked" class="check-all-toggle" color="blue" @input="toggleAllCheckboxes" />
            <div class="bold">{{ $t('checkAll') }}</div>
          </div>
        </div>
      </div>
      <div
        class="email-wrapper"
        :class="{ integration: mode === 'integration-not-in-clavo' || mode === 'clavo-not-in-integration' || mode === 'connect-clavo-to-integration' }"
      >
        <div
          v-if="(mode === 'clavo-not-in-integration' || mode === 'integration-not-in-clavo') && showIllustration && members.length === 0"
          class="placeholder"
        >
          <img src="@/assets/illustrations/sloth-sleeping-gray-blue.svg" alt="Sleeping sloth" />
          <div v-if="mode === 'clavo-not-in-integration'" class="title">{{ $t('allTeamMembersConnected') }}</div>
          <div v-if="mode === 'integration-not-in-clavo'" class="title">{{ $t('allIntegrationMembersInClavo') }}</div>
        </div>

        <transition-group name="list" tag="span">
          <div v-for="(el, index) in startedInviting ? emailsRemaining : emails" :key="el.id" class="invite-person">
            <div v-if="mode === 'clavo-not-in-integration'" class="list-item">
              <member-name-box :member="el"></member-name-box>

              <div
                v-if="el.integrations && el.integrations[system] && el.integrations[system]._id"
                class="clavo-link primary bold danger"
                @click="disconnectClicked(el)"
              >
                {{ $t('disconnect') }}
              </div>
              <div v-else class="clavo-link primary bold" @click="connectClicked(el)">
                {{ $t('connect') }}
              </div>
            </div>
            <div v-else-if="mode === 'integration-not-in-clavo'" class="grid-item">
              <checkbox
                :key="'checkbox' + index"
                v-model="checked[index]"
                :initial-state="checked[index]"
                class="check"
                color="blue"
                @input="toggleOneCheckbox(index)"
              />
              <div class="bold">{{ el.name }}</div>
              <div>{{ el.email }}</div>
            </div>
            <div v-else-if="mode === 'connect-clavo-to-integration'" class="grid-item">
              <radio-button
                :key="'radio' + el.id"
                class="radio-button"
                :checked="memberTo === el"
                @click="
                  () => {
                    memberTo = el
                    $emit('member-selected', el)
                  }
                "
              />
              <div class="bold">{{ el.name }}</div>
              <div>{{ el.email }}</div>
            </div>
            <div v-else class="invite-email">
              <editable-input
                :key="el.id"
                :ref="'email'"
                v-model="el.email"
                :placeholder="'name@example.com'"
                :validation-function="emailValid"
                lazy-validation
                :title="$t('email')"
                disable-auto-complete
                :incorrect-value-msg="el.email === '' ? '' : $t('invalidEmail')"
                :autofocus="index == 0"
                @input="validateEmails"
                @focus-next-input="focusNext(index)"
                @focus-out="checkMailAtBlur(index)"
              />
              <!--                <input type="email"-->
              <!--                       :id="'email'+index"-->
              <!--                       v-model="emails[index]"-->
              <!--                       placeholder="name@example.com"-->
              <!--                       @input="validateEmails()"/>-->

              <img class="delete" src="@/assets/ico/close-L-gray.svg" alt="delete" :title="$t('removeEmail')" @click="deleteEmail(index)" />
            </div>
          </div>
        </transition-group>
      </div>
      <p class="vmiddle">
        <a v-if="emails.length < maxAmountOfEmails" href="" class="with-images" @click.prevent="addEmail">
          <img src="@/assets/ico/plus_round_24px.svg" alt="+" />
          &nbsp;{{ $t('addMore') }}
        </a>
        <!-- <br><br>
        <span>{{ emails.length < maxAmountOfEmails ? $t('orGetThe') : '' }} &nbsp;
          <a
            class="with-images clavo-link primary"
            @click="generateMagicLink"
          >
            <img
              src="@/assets/ico/invitelink_round_24px.svg"
              alt="link"
            >
            &nbsp;{{ $t('inviteLink').toLowerCase() }} </a>.
          <a :href="slackUrl"> <img
            class="slack-button"
            src="https://api.slack.com/img/sign_in_with_slack@2x.png"
          ></a>
        </span> -->
      </p>
      <div v-if="['free', 'incomplete_expired', 'unpaid', 'canceled'].includes(currentTeam.status) && !currentTeam.isTrial" class="free-info">
        {{ $t('youCanInviteUpToX', { x: currentTeam.maxMembers, team: team.name }) }}
        <a href="" class="clavo-link primary" @click.prevent="goToUpgrade">{{ $t('upgradeOptions') + '.' }}</a>
      </div>
      <div class="buttons-bar" :class="{ integration: mode === 'integration-not-in-clavo' || 'clavo-not-in-integration' || 'connect-clavo-to-integration' }">
        <button v-if="!noBack" class="clavo-button secondary back" @click="backClicked">
          {{ $t('back') }}
        </button>
        <div v-else />
        <button
          v-if="!isIntegration"
          class="clavo-button primary button-submit"
          :class="{ active: allValid && !startedInviting }"
          :disabled="!allValid || startedInviting"
          @click="invite"
        >
          {{ $t('inviteTeammates') }}
        </button>
        <button
          v-else-if="mode === 'clavo-not-in-integration'"
          class="clavo-button primary button-submit"
          :class="{ active: allValid && !startedInviting }"
          :disabled="!allValid || startedInviting"
          @click="continueClicked()"
        >
          {{ $t('continue') }}
        </button>
        <button v-else-if="mode === 'integration-not-in-clavo' && members.length > 0" class="clavo-button primary button-submit active" @click="doneClicked()">
          {{ $t('done') }}
        </button>
        <button
          v-else-if="mode === 'integration-not-in-clavo' && members.length === 0"
          class="clavo-button primary button-submit active"
          @click="$emit('close')"
        >
          {{ $t('done') }}
        </button>
        <button
          v-else-if="mode === 'connect-clavo-to-integration'"
          class="clavo-button primary button-submit"
          :class="{ active: memberTo }"
          :disabled="!memberTo || $store.state.showProgressBar"
          @click="connectClicked(memberTo)"
        >
          {{ $t('connect') }}
        </button>
      </div>
    </div>
    <div v-else class="invite link" :class="{ modal: modal }">
      <div v-if="!link.hasExpired" class="link-button-wrapper">
        <div class="link-wrapper">
          <label>{{ $t('inviteLinkFor', { teamName: team.name }) }}</label>
          <editable-input :key="link.url" :value="link.url" class="input-link" disabled />
        </div>
        <button v-clipboard:copy="link.url" class="clavo-button secondary" @click="copyLink">
          {{ $t('copy') }}
        </button>
      </div>
      <div v-if="!link.hasExpired" class="link-expiry-wrapper">
        <p>
          {{ $tc('linkExpires', linkExpires, { days: linkExpires }) }}
        </p>
        <div class="clavo-link danger" @click="deactivateLink">
          {{ $t('deactivateLink') }}
        </div>
      </div>
      <div v-else class="link-expiry-wrapper">
        <p>{{ $t('linkExpired') }}</p>
        <div class="clavo-link primary" @click="regenerateNewLink">
          {{ $t('regenerateInvitationLink') }}
        </div>
      </div>

      <div class="buttons-bar">
        <button
          class="clavo-button secondary back"
          @click="
            () => {
              stage = 'selectMethod'
              $emit('sync-without-slack')
            }
          "
        >
          {{ $t('back') }}
        </button>
        <!-- <button
          class="clavo-button primary done"
          @click="$emit('done')"
        >
          {{ $t('done') }}
        </button> -->
      </div>
    </div>
  </div>
</template>

<script>
import Parse from 'parse'
import Validation from '@/components/Validation'
import ParseFunctions from '@/components/ParseFunctions'
import EditableInput from '@/components/UI/EditableInput'
import Checkbox from '@/components/UI/Checkbox'
import RadioButton from '@/components/UI/RadioButton'
import SearchBar from '@/components/UI/SearchBar'
import EventBus from '@/EventBus'
import moment from 'moment-timezone'
import ProgressBar from '@/components/UI/ProgressBar'
import MemberNameBox from '@/components/Team/MemberNameBox'
import Constants from '@/components/Constants'

export default {
  name: 'InvitationForm',
  components: {
    ProgressBar,
    EditableInput,
    MemberNameBox,
    Checkbox,
    RadioButton,
    SearchBar,
  },
  mixins: [Validation, ParseFunctions, Constants],
  props: {
    team: { type: Object, default: undefined },
    teamId: { type: String, default: undefined },
    modal: {
      type: Boolean,
      default: false,
    },
    mode: { type: String, default: undefined },
    system: { type: String, default: undefined },
    members: { type: Array, default: undefined },
    memberFrom: { type: Object, default: undefined },
    showIllustration: { type: Boolean, default: false },
    onboarding: { type: Boolean, default: false },
  },
  data() {
    return {
      checked: [],
      emails: [
        {
          id: Math.floor(Math.random() * Date.now()).toString() + 'email',
          email: '',
          valid: true,
        },
        {
          id: Math.floor(Math.random() * Date.now()).toString() + 'email',
          email: '',
          valid: true,
        },
        {
          id: Math.floor(Math.random() * Date.now()).toString() + 'email',
          email: '',
          valid: true,
        },
      ],
      emailsValid: [],
      emailsRemaining: [],
      startedInviting: false,
      allValid: true,
      stage: 'selectMethod',
      link: '',
      maxAmountOfEmails: 0,
      linkParams: undefined,
      currentMails: 0,
      totalMails: 0,
      showProgressBar: false,
      hideAfterSending: true,
      memberTo: undefined,
      search: undefined,
      allChecked: true,
    }
  },
  computed: {
    noBack() {
      return this.mode === 'clavo-not-in-integration'
    },
    isIntegration() {
      return this.mode !== 'invite'
    },
    linkExpires() {
      return moment(this.link.expirationDate).diff(moment(), 'days')
    },

    currentTeam() {
      return this.team || this.$store.getters.teamById(this.$route.query.teamId)
    },
  },
  watch: {
    members: function () {
      this.refreshEmails()
    },
  },
  async created() {
    if (this.isIntegration) {
      this.stage = 'byMail'
    }

    if (this.stage === 'invite') {
      this.hideAfterSending = false
    }
    if (this.members) {
      this.refreshEmails()
    } else {
      if (this.currentTeam && this.currentTeam.maxMembers && this.currentTeam.activeMembersCount) {
        this.maxAmountOfEmails = this.currentTeam.maxMembers - this.currentTeam.activeMembersCount
      } else {
        this.maxAmountOfEmails = 200 - 1
      }
      for (let i = this.emails.length; i > this.maxAmountOfEmails; i--) {
        this.emails.splice(0, 1)
      }
    }
  },
  mounted() {
    if (this.$refs.email && this.$refs.email.length > 0) this.$refs.email[0].focusIn()
    if (!this.isIntegration) {
      this.validateEmails()
    }
  },
  methods: {
    async goToIntegrations(system) {
      if (this.onboarding) {
        this.$store.commit('setCreatedTeamId', undefined)
        let res = await this.getIntegrationInstallUrl(this.teamId, 'teamIntegrationsSettings', system)
        if (res.status === 'ok') {
          let state = res.state
          window.open(res.url, '_self')
        } else {
          this.showServerError(res)
        }
      } else {
        this.$nextTick(() => {
          EventBus.$emit('component-selected', {
            componentName: 'AdminSettings',
            tabName: 'TeamIntegrationsSettings',
            teamId: this.teamId,
            type: 'teamSetting',
          })
        })
      }
    },
    refreshEmails() {
      let tempEmails = []
      let i = 0
      for (const member of this.members) {
        if (!this.search || member.name.toLowerCase().includes(this.search.toLowerCase())) {
          if (member && !member.valid) member.valid = true
          if (!member.id) member.id = Math.floor(Math.random() * Date.now()).toString() + 'email'
          if (this.mode === 'integration-not-in-clavo') {
            this.checked[i] = true
            i++
          }
          tempEmails.push(member)
        }
      }
      this.emails = tempEmails
    },
    async goToUpgrade() {
      EventBus.$emit('show-upgrade-plan', {
        teamId: this.teamId,
      })
    },
    focusNext(index) {
      if (this.checkMailAtBlur(index)) {
        if (index + 1 >= this.emails.length) {
          this.addEmail()
        }
        setTimeout(
          function () {
            this.$refs.email[index + 1].focusIn()
          }.bind(this),
        )
      }
    },
    checkMailAtBlur(index) {
      if (this.emails[index].email !== '') return this.$refs.email[index].validate()
      else return false
    },
    addEmail() {
      if (this.emails.length < this.maxAmountOfEmails) {
        this.emails.push({
          id: Math.floor(Math.random() * Date.now()).toString() + 'email',
          email: '',
          valid: true,
        })
        this.validateEmails()
        setTimeout(() => {
          let emailWrapper = document.getElementsByClassName('email-wrapper')
          if (emailWrapper) {
            emailWrapper[0].scrollTo(0, emailWrapper[0].scrollHeight) // scroll to the new email input
            let inputWrappers = emailWrapper[0].getElementsByClassName('input-wrapper')
            if (inputWrappers) inputWrappers[inputWrappers.length - 1].children[0].focus() // focus on the new email input
          }
        }, 100)
      }
    },
    deleteEmail(index) {
      this.emails.splice(index, 1)

      this.validateEmails()
    },
    async deactivateLink() {
      let res = await this.deactivateInvitationLink(this.teamId)
      // console.log(res)
      this.link.expirationDate = res.expirationDate
      this.link.url = ''
      this.link.hasExpired = true
    },
    validateEmails() {
      let allValid = false
      let allEmpty = true
      for (let i = 0; i < this.emails.length; i++) {
        let email = this.emails[i]
        if (email.email !== '') allEmpty = false
        let valid = this.emailValid(email.email)
        email.valid = valid
        allValid = allValid || valid
      }

      this.allValid = allValid && !allEmpty
    },
    async invite() {
      this.emails = this.emails.filter((el) => el.email != '')
      if (this.isIntegration) {
        let emailsFiltered = []
        for (var i = 0; i < this.emails.length; i++) {
          if (this.checked[i]) {
            emailsFiltered.push(this.emails[i])
          }
        }
        this.emails = emailsFiltered
      }
      this.emailsRemaining = JSON.parse(JSON.stringify(this.emails)) // deep copy
      this.totalMails = this.emails.length

      // if 0 members checked
      if (this.totalMails === 0) {
        this.stage = 'selectMethod'
        EventBus.$emit('invite-done')
        this.emails = [
          {
            id: Math.floor(Math.random() * Date.now()).toString() + 'email',
            email: '',
            valid: true,
          },
        ]
        if (this.hideAfterSending) {
          this.$emit('close')
        }
        EventBus.$emit('refresh-team-members', {
          team: this.teamId,
        })
        return
      }

      this.startedInviting = true // switches displayed list of emails from this.emails to this.emailsRemaining
      this.showProgressBar = true

      if (process.env.IS_TESTING_SERVER) {
        await Parse.Cloud.run('setTestingHostAndPort', { host: location.protocol + '//' + location.host }, {})
      }

      let resTeam = await this.getTeamById(this.teamId)

      let errors141Found = 0
      let errorsOtherFound = 0

      this.$store.commit('setShowProgressBar', true)
      if (this.isIntegration) {
        let res = await this.assignExternalIdsToClavoTeamMembers(this.teamId, this.system)
        if (res.status === 'ok') {
        } else {
          this.showServerError(res)
        }
      }

      for (const user of this.emails) {
        if (user.valid) {
          var res
          if (!this.isIntegration) {
            res = await this.addTeamMember(user.email, this.teamId, user.timezone ? user.timezone : resTeam.settings.timezone, user.name ? user.name : '')
          } else {
            res = await this.addTeamMember(
              user.email,
              this.teamId,
              user.timezone ? user.timezone : resTeam.settings.timezone,
              user.name ? user.name : '',
              this.system,
              user.externalUserId,
            )
          }

          if (res.status == 'ok' || res.error == 'TEAM_MEMBER_ALREADY_INVITED') {
            let index = this.emailsRemaining.findIndex((el) => el.email == user.email)
            this.emailsRemaining.splice(index, 1)
            this.currentMails++
          } else if (res.code === 141) {
            errors141Found++
          } else {
            errorsOtherFound++
          }
        }
      }

      this.$store.commit('setShowProgressBar', false)
      this.showProgressBar = false

      if (this.emailsRemaining.length > 0) {
        this.emails = this.emailsRemaining
        this.startedInviting = false
      }

      if (errors141Found + errorsOtherFound > 0) {
        EventBus.$emit('new-info-bar-msg', {
          msg: errors141Found + errorsOtherFound + ' of your invitations failed!',
          error: true,
        })
      }

      if (errors141Found > 0) {
        setTimeout(() => {
          EventBus.$emit('new-info-bar-msg', {
            msg: this.$t('pleaseFixBillingBeforeAddingNewUsers'),
            error: true,
          })
        }, 5000)
      }

      if (errors141Found == 0 && errorsOtherFound == 0) {
        EventBus.$emit('new-info-bar-msg', {
          msg: this.$t('invitesToYourTeamMates'),
        })
        this.stage = 'selectMethod'
        EventBus.$emit('invite-done')
        this.startedInviting = false
        this.emails = [
          {
            id: Math.floor(Math.random() * Date.now()).toString() + 'email',
            email: '',
            valid: true,
          },
        ] // reset this.emails to default
        if (this.hideAfterSending) {
          this.$emit('close')
        }
      }

      EventBus.$emit('refresh-team-members', {
        team: this.teamId,
      })
    },

    async connectClicked(userTo) {
      if (this.mode === 'clavo-not-in-integration') {
        this.emails = []
        this.$emit('connect', { member: userTo })
      } else {
        // mode == connect-clavo-to-integration
        this.$store.commit('setShowProgressBar', true)
        let res = await this.connectExternalUser(this.system, this.team.teamId, this.memberFrom.id, userTo.externalUserId)
        this.$store.commit('setShowProgressBar', false)

        if (res.status == 'ok') {
          EventBus.$emit('back')
        } else {
          this.showServerError(res)
        }
      }
    },

    async disconnectClicked(user) {
      this.$store.commit('setShowProgressBar', true)
      let res = await this.disconnectExternalUser(this.system, this.team.teamId, user.id)
      this.$store.commit('setShowProgressBar', false)

      if (res.status == 'ok') {
        this.$emit('disconnected', user)
      } else {
        this.showServerError(res)
      }
    },

    async generateMagicLink() {
      this.link = await this.getTeamMemberInvitationLink(this.teamId)
      if (this.link.hasExpired) {
        this.link.url = ''
      }
      // console.log('getTeamMemberInvitationLink res', this.link)
      this.stage = 'byLink'
    },
    async regenerateNewLink() {
      this.link = await this.regenerateInvitationLink(this.teamId)
      // console.log(this.linkExpires)
    },
    copyLink() {
      EventBus.$emit('new-info-bar-msg', {
        msg: this.$t('inviteLinkCopied'),
        timeout: 5000,
      })
    },
    backClicked() {
      if (this.mode === 'invite') {
        this.stage = 'selectMethod'
      } else if (this.mode === 'connect-clavo-to-integration' || this.mode === 'integration-not-in-clavo') {
        this.emails = []
        EventBus.$emit('back')
      }
    },
    continueClicked() {
      this.emails = []
      this.$emit('continue')
    },
    async doneClicked() {
      await this.invite()
    },
    searchMembers(input) {
      this.search = input
      this.refreshEmails()
    },
    toggleOneCheckbox(index) {
      if (!this.checked[index]) {
        this.allChecked = false
      }
    },
    toggleAllCheckboxes() {
      for (var i = 0; i < this.checked.length; i++) {
        this.checked[i] = this.allChecked
      }
    },
  },
}
</script>

<style lang="scss">
// Overwriting the editable input
.invite-person {
  &:not(:first-child) {
    .editable-input-wrapper .header-wrapper {
      display: none;
    }
  }
}
</style>

<style lang="scss" scoped>
.invite {
  padding-bottom: 24px;
  @include respond-below(sm) {
    padding-bottom: 0;
  }
  &.selection {
    button {
      padding-top: 28px;
      padding-bottom: 28px;
      margin-bottom: 12px;
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
      span.icon-w-text {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        svg {
          margin-right: 18px;
        }
        span {
          font-family: $bold;
        }
      }

      &:hover {
        svg path,
        svg circle {
          fill: #fff;
        }
        svg path.negative,
        svg circle.negative {
          fill: $blue;
        }
      }
      &:last-of-type {
        margin-bottom: 0;
      }

      &.big {
        padding-top: 0;
        padding-bottom: 0;
      }
    }
    .skip {
      margin-top: 60px;
      button {
        width: auto;
        justify-content: center;
        @include respond-below(sm) {
          width: 100%;
        }
      }
    }
    .integrations-info {
      margin-top: 12px;
      p {
        font-size: 16px;
        color: $blue;
        span {
          display: inline-flex;
          @include font-rule('averta-bold');
          img {
            transform: scaleX(-1);
          }
        }
      }
    }
  }

  &.email {
    .progress-bar-wrapper {
      margin-bottom: 24px;
      p {
        margin-bottom: 4px;
      }
    }
    .email-wrapper {
      .list-enter-active,
      .list-leave-active {
        transition: all 0.2s ease-in-out;
      }
      .list-enter,
      .list-leave-to {
        opacity: 0;
      }
      min-height: 210px;
      margin-bottom: 10px;
      overflow-y: auto;
      scroll-behavior: smooth;
      &.integration {
        border: 1px solid $flax-bloom;
        padding: 10px 15px 0;
      }
    }
    .search-user {
      margin-bottom: -1px;
    }
    .button-submit {
      padding: 0 40px;
      cursor: auto;
      background-color: #fff;
      color: #b2b6e1;
      border: 1px solid #b2b6e1;

      margin-right: 20px;

      &.active {
        cursor: pointer;
        background-color: $blue;
        color: #fff;
        border: 1px solid $blue;

        &:hover {
          background-color: white;
          color: $blue;
        }
      }
    }
    .check-all-outer-wrapper {
      border: 1px solid $flax-bloom;
      border-bottom-width: 0px;

      .check-all-inner-wrapper {
        margin-right: 10px;

        .grid-item {
          display: grid;
          grid-template-columns: 30px 1fr;
          grid-column-gap: 10px;
          align-items: center;
          padding: 10px 15px;

          .check-all-toggle {
            margin: 0;
            font-size: 12px;
            display: block;
          }
          div {
            font-size: 15px;
          }
        }
      }
    }

    .invite-person {
      margin-bottom: 18px;
      margin-right: 10px;

      p.alert-warning {
        display: none;
        &.incorrect {
          display: inline;
        }
      }
      label {
        font-size: 12px;
        text-transform: uppercase;
        display: block;
        margin-top: 30px;
        margin-bottom: 5px;
      }

      .list-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 3px 0;
        .clavo-link {
          font-size: $font-size-paragraph;
        }
      }
      .grid-item {
        display: grid;
        grid-template-columns: 30px 1fr 1fr;
        align-items: center;
        grid-row-gap: 28px;
        grid-column-gap: 10px;
        label {
          margin: 0;
        }
        div {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 15px;
        }
        .radio-button {
          margin-top: 0px;
          margin-bottom: -15px;
        }
      }

      .invite-email {
        display: flex;
        align-items: flex-start;
        & > div {
          flex: 1;
        }
        img.delete {
          cursor: pointer;
          margin: 12px 11px;
          transition: opacity 0.2s ease-in-out;
          &:hover {
            opacity: 0.6;
          }
        }
      }

      &:first-child {
        .invite-email {
          img.delete {
            margin-top: 36px;
          }
        }
      }
    }

    p.vmiddle {
      span {
        display: inline-flex;
        align-items: center;
      }
      // display: flex;
      // align-items: center;

      a.with-images {
        display: inline-flex;
        align-items: center;
        font-family: $bold;
        transition: opacity 0.2s ease-in-out;
        img {
          margin-right: 4px;
        }
        &:hover {
          opacity: 0.6;
        }
      }
    }

    .free-info {
      font-size: 14px;
      line-height: 20px;
      color: $bluebell;
      white-space: pre-wrap;
      margin-top: 24px;
    }

    // Specific styles added in case of onboarding inline form
    &.inline {
      button {
        float: none;
        // big style copied below:
        height: 50px;
        min-width: 240px;
        @include respond-below(xs) {
          width: 100%;
        }
      }
      .invite-person {
        .invite-email {
          img.delete {
            margin-top: 15px;
          }
        }
        &:first-child {
          .invite-email {
            img.delete {
              margin-top: 39px;
            }
          }
        }
      }
    }
  }

  &.link {
    .link-button-wrapper {
      display: flex;
      flex-direction: row;
      align-items: flex-end;

      .link-wrapper {
        margin-right: 20px;
        flex: 1;
        label {
          @include label;
        }
        .input-link {
          margin-top: 6px;
        }
      }
      button {
        min-width: 100px;
        height: 46px;
      }
      @include respond-below(sm) {
        flex-direction: column;
        align-items: flex-start;
        .link-wrapper {
          margin-right: 0;
          margin-bottom: 12px;
          width: 100%;
        }
        button {
          width: 100%;
        }
      }
    }
    &.modal {
      .link-button-wrapper {
        button {
          height: auto;
        }
      }
    }
    .link-expiry-wrapper {
      margin-top: 24px;
      margin-bottom: 96px;

      div {
        @include font-rule('averta-regular');
        font-size: 14px;
      }
    }
  }
  &.modal {
    .buttons-bar {
      flex-direction: row;
      justify-content: space-between;
      &.integration {
        margin-top: 24px;
      }
      .button-submit {
        margin-right: 0;
      }
    }
  }
  .buttons-bar {
    display: flex;
    justify-content: flex-end;
    flex-direction: row-reverse;
    margin-top: 50px;
    .button-submit {
      @include respond-below(sm) {
        margin-right: 0;
      }
    }
    .back {
      @include respond-below(sm) {
        margin-right: 0;
      }
      min-width: 100px;
    }
    .done {
      min-width: 100px;
    }
    @include respond-below(sm) {
      flex-direction: column-reverse;
      button {
        margin-top: 12px;
      }
    }
  }
}

.placeholder {
  display: grid;
  justify-content: center;
  text-align: center;
  color: $bluebell;
  padding: 0px 0px 20px;
  img {
    width: 250px;
    margin: auto;
  }
  .title {
    @include font-rule('averta-bold');
    font-size: 16px;
    line-height: 24px;
    max-width: 25ch;

    margin-top: 8px;
  }
}
</style>
